/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Plans_Team_DescriptionInputs */

const es_components_upgrade_plan_modal_plans_team_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Team_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseñado para equipos que ya necesitan colaboración y acceso a API.`)
};

const en_components_upgrade_plan_modal_plans_team_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Team_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for teams that already need collaboration and API access.`)
};

/**
* | output |
* | --- |
* | "Built for teams that already need collaboration and API access." |
*
* @param {Components_Upgrade_Plan_Modal_Plans_Team_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_plans_team_description = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Plans_Team_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Plans_Team_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_plans_team_description(inputs)
	return en_components_upgrade_plan_modal_plans_team_description(inputs)
});
export { components_upgrade_plan_modal_plans_team_description as "components.upgrade_plan_modal.plans.team.description" }